import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators, ValidationErrors } from '@angular/forms';
import { formatDate } from '@angular/common';

@Component({
  selector: 'lib-date-picker',
  templateUrl: './date-picker.component.html',
  styleUrls: ['./date-picker.component.css']
})
export class DatePickerComponent implements OnInit {

  public form: UntypedFormGroup;
  public dateString: string = "";

  public dateValue: Date | null;
  @Input()
  isFromDate: boolean = false;

  @Output()
  valueChange = new EventEmitter<Date>();


  @Input()
  get value() {
    return this.dateValue;
  }
  set value(val) {
    this.dateValue = val;

    if (val) {
      this.form.get('datebox').setValue(formatDate(this.dateValue, "MM/dd/yyyy", "en-US"));
      this.valueChange.emit(this.dateValue);
   }
  }


  constructor(private fb: UntypedFormBuilder) { }

  ngOnInit() {
    this.form = this.fb.group({
      'datebox': [this.dateString, [Validators.required]]
    }, { validators: this.isValidDateFormatValidator });

    this.form.valueChanges.subscribe(value => {
      //console.log(`inside valueChanges value: ${JSON.stringify(value)}`);
      //console.log(`is form valid: ${this.form.valid}`);
      if (value.datebox) {
        let last: string = value.datebox[value.datebox.length - 1];
        //console.log(`last: ${last}`);
        //console.log(`!!Number(last): ${!!Number(last)}`);
        //console.log(`is equal to '/' or '-': ${last === '/' || last === '-'}`);

        if (!!Number(last) || last === '/' || last === '-' || last === '0') {
          this.dateString = value.datebox
        } else {
          //console.log(`value.datebox.slice: ${value.datebox.slice(0, -1)}`);
          //value.datebox = value.datebox.slice(0, -1);

          this.dateString = value.datebox.slice(0, -1);
          //this.form.updateValueAndValidity({ onlySelf: true, emitEvent: false});
          this.form.get('datebox').setValue(this.dateString, { onlySelf: true, emitEvent: false });
          //console.log(`dateString: ${this.dateString}`);
        }
      } else {
        this.dateString = "";
      }
    });
  }

  isValidDateFormatValidator(control: UntypedFormGroup): ValidationErrors | null {
    //console.log('+++++++++++++++isValidDateFormatValidator fired');
    let stringval = control.get('datebox').value;
    let newDate = new Date(stringval);
    //console.log(`newDate is invalid: ${newDate.toString() === "Invalid Date"}`);
    if (newDate.toString() === 'Invalid Date') {
      return { invalidDate: true };
    }
    //console.log(`newDate: ${newDate}`);
    return null;

  }
  onBlur(e: any) {
    //console.log('+++++++++++++++++++onBlur fired');
    //console.log(`form.valid: ${this.form.valid}`);
    if (this.form.valid) {
      //Detect YYYY pattern in dateString
      if (!!Number(this.dateString) && this.dateString.length == 4) {
        //console.log(`WE HAVE A YEAR: ${this.dateString}`);
        if (this.isFromDate) {
          this.dateString = `1/1/${this.dateString}`;
        } else {
          this.dateString = `12/31/${this.dateString}`;
        }
        this.value = new Date(this.dateString);

      } else {
        this.value = new Date(this.dateString);
      }
      //console.log(`this.value: ${this.value}`);

    }
  }
}
